import { Component, ErrorHandler, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { AviationEventsService } from '../../shared/services/aviation-events.service';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { AviationEventPhoto } from '../../shared/models/aviation-event-photo.model';
import { NgxGalleryOptions, NgxGalleryImage, NgxGalleryAnimation } from 'ngx-gallery';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
import { State } from '../../shared/state-view/state.model';
import { ImageUploadComponent } from '../../shared/image-upload/image-upload.component';
import { IEntity } from '../../shared/models/entity.model';


@Component({
  selector: 'app-edit-event-image',
  templateUrl: './edit-event-image.component.html',
  styleUrls: ['./edit-event-image.component.scss']
})
export class EditEventImageComponent implements OnInit {
  formGroup: FormGroup;
  aviationEvent: AviationEvent;
  _originImage: AviationEventPhoto;
  isBusy = false;
  eventCoverImage: File;
  galleryOptions: NgxGalleryOptions[];
  galleryImages: NgxGalleryImage[];
  writtenPhotoIds: Array<number> = [];
  newPhotoIds: Array<number> = [];
  entity: IEntity;


  constructor(private _matDialogRef: MatDialogRef<EditEventImageComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _aviationEventsService: AviationEventsService,
              private _fb: FormBuilder,
              private _snackBar: MatSnackBar,
              public dialog: MatDialog,
              private _errorHandler: ErrorHandler) {
    this.aviationEvent = data.aviationEvent;
    if (this.aviationEvent.photos && this.aviationEvent.photos.length > 0) {
      this._originImage = this.aviationEvent.photos[0];
    } else {
      this._originImage = null;
    }
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this._matDialogRef.close(null);
    });

    this.formGroup = this._fb.group({
      coverPhoto: ['', [this.requiredFileType(['jpg', 'png', 'jpeg', 'gif'])]]
    }, {updateOn: 'submit'});

    this.entity = {
      id: this.aviationEvent.eventId,
      name: this.aviationEvent.title,
      type: 'Event'
    };

    this.galleryOptions = [
      {
        width: '341px',
        // height: '255px', // for block with image preview
        height: '80px',
        thumbnailsColumns: 3,
        image: false, // remove to have image preview
        imageSize: 'contain',
        //  imageAnimation: NgxGalleryAnimation.Slide
        thumbnailsMargin: 5,
        thumbnailMargin: 5,
        imageArrowsAutoHide: true,
        thumbnailsArrowsAutoHide: true
      }
    ];

    if (this.aviationEvent.galleryPhotos) {
      this.galleryImages = this.aviationEvent.galleryPhotos;
    } else {
      this.galleryImages = [];
    }

    if (this.aviationEvent.photos) {
      this.aviationEvent.photos.forEach((photo) => {
        this.writtenPhotoIds.push(photo.photoId);
      });
    } else {
      this.writtenPhotoIds = [];
    }
  }

  requiredFileType(types: string[]) {
    return function (control: FormControl) {
      const fileName = control.value;
      if (fileName) {
        const extension = fileName.split('.').pop().toLowerCase();
        let hasExtension = false;
        types.forEach(it => {
          if (it.toLowerCase() === extension.toLowerCase()) {
            hasExtension = true;
            return;
          }
        });
        if (!hasExtension) {
          return {
            requiredFileType: true
          };
        }
      }
    };
  }

  async deleteImage(index: number) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      data: 'Delete this image?'
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        // if user confirmed delete
        const snackBarOpts = {duration: 2000};
        try {
          if (index < this.writtenPhotoIds.length) {
            this._aviationEventsService.deleteEventCoverImg(this.aviationEvent.eventId, this.writtenPhotoIds[index]);
            this.writtenPhotoIds.splice(index, 1);
          } else {
            this.newPhotoIds.splice(index, 1);
          }
          this.galleryImages.splice(index, 1);
        } catch (e) {
          this._snackBar.open('An error occurred deleting the image. Please try again later.', 'Dismiss', snackBarOpts);
          this._errorHandler.handleError(e);
        }
      }
    });
  }

  async openAddImageDialog() {
    const dialogRef = this.dialog.open(ImageUploadComponent, {
      width: '500px',
      data: { images: this.galleryImages, entity: this.entity, newPhotoIds: this.newPhotoIds }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        // if user confirmed delete
        const snackBarOpts = {duration: 2000};
        try {
          this.newPhotoIds.forEach((photoId) => {
            if (!this.writtenPhotoIds.includes(photoId)) {
              this.writtenPhotoIds.push(photoId);
            }
          });
        } catch (e) {
          this._snackBar.open('An error occurred deleting the review. Please try again later.', 'Dismiss', snackBarOpts);
          this._errorHandler.handleError(e);
        }
      }
    });
  }

  cancel () {
    if (this._originImage) {
      this.aviationEvent.photos = new Array<AviationEventPhoto>();
      this.aviationEvent.photos.push(this._originImage);
    } else {
      this.aviationEvent.photos = null;
    }
    this._matDialogRef.close(null);
  }

  async save () {
    if (this.formGroup.invalid) {
      this._snackBar.open('Form field validation failed. check form values', null, {duration: 5000});
      return;
    }

    try {
      this.isBusy = true;
        this.newPhotoIds.forEach( async (photoId) => {
          const photo = await this._aviationEventsService.putEventPhoto(this.aviationEvent.eventId, photoId);
        });
      this.isBusy = false;
      this._matDialogRef.close(true);
    } catch (e) {
      this.isBusy = false;
      this._matDialogRef.close(false);
    }

  }
}
